import { render, staticRenderFns } from "./winners.page.vue?vue&type=template&id=bc73788c&scoped=true"
import script from "./winners.page.vue?vue&type=script&lang=js"
export * from "./winners.page.vue?vue&type=script&lang=js"
import style0 from "./winners.page.vue?vue&type=style&index=0&id=bc73788c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc73788c",
  null
  
)

export default component.exports